import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import ClinicalThemeToggle from "../components/ClinicalThemeToggle";

const CheckoutCancelPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center p-6">
      <div className="absolute top-4 right-4">
        <ClinicalThemeToggle />
      </div>
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <XCircle className="w-12 h-12 text-muted-foreground mx-auto mb-2" />
          <CardTitle>{t("billing.cancelTitle")}</CardTitle>
          <CardDescription>{t("billing.cancelDesc")}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          <Button asChild>
            <Link to="/case/new">{t("billing.backToCases")}</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/account">{t("account.billing")}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default CheckoutCancelPage;
